module.exports = __webpack_public_path__ + "static/img/twjd-sdl3-2.fa4bfe6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdl3-2.png
// module id = 232
// module chunks = 0